// extracted by mini-css-extract-plugin
export default {"solidgaugeWrapper":"MultipleKPIGaugeChart_solidgaugeWrapper__gsfQL","solidgaugeTitleWrapper":"MultipleKPIGaugeChart_solidgaugeTitleWrapper__tKZFE"};